import './sidenav.scss';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import SideNavItem from 'components/header/sidenav/sidenav-item';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'types';
import { useParams } from 'react-router';

function SideNav({
    open, setOpen
}:{
    open: boolean,
    setOpen: Dispatch<SetStateAction<boolean>>
}
) {
    const params: any = useParams();
    const dispatch = useDispatch();
    const [active, setActive] = useState<any>(null);
    const state = useSelector((state: RootState) => state);

    const sideNavContent = [
        {
            heading: "Dashboard",
            productId: null,
            icon: <i className="fal fa-home icon"></i>,
            children: [],
            navigateTo: "/dashboard",
        },
        {
            heading: "Model Builder",
            productId: null,
            icon: <i className="fal fa-clipboard-list icon"></i>,
            children: [],
            navigateTo: "/search",
        }
    ]

    return (
        <div id="sidenav" className={`${open ? 'open' : ''}`}>
            <div className="overlay" onClick={() => setOpen(false)}></div>
            <div className="sidenav-content">
                {sideNavContent.map((x: any, i: number) => {
                    return (
                        <SideNavItem 
                            heading={x.heading}
                            icon={x.icon}
                            children={x.children}
                            active={active}
                            setActive={setActive}
                            open={open}
                            key={i}
                            navigateTo={x.navigateTo}
                        />
                    )
                })}
            </div>
        </div>

    )
}

export default SideNav;